import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import {
  CustomSelect,
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import CustomSwitch from "components/Input/CustomSwitch.js";
import { putPoints } from "services/ConfigServices";
import styled from "styled-components";
import { dico } from "variables/lists/dico";
import { stateData, stateNotControlableData } from "variables/MBM/lists/equipments";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function PointDialog(props) {
  const memv2versionactive = localStorage.getItem('memv2version') || 0;
  const { closeModal, refetch, setNotification, points } = props;

  const [definition, setDefinition] = useState("");
  const [state, setState] = useState(0);
  const [controlable, setControlable] = useState(false);
  const [groupid, setGroupid] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [definitionUpdate, setDefinitionUpdate] = useState(false);
  const [stateUpdate, setStateUpdate] = useState(false);
  const [controlableUpdate, setControlableUpdate] = useState(false);
  const [groupsUpdate, setGroupsUpdate] = useState(false);

  const dicowithequipmentname = dico.map((row) => {
    let newrow = { ...row };
    newrow.name = row.equipmentname + " - " + row.name + " - " + row.unit + " (" + row.id + ")";
    return newrow;
  });

  const selectedDefinition = () => {
    let selected = dicowithequipmentname.find((obj) => obj.id == definition);
    return selected;
  };

  const handleDefinitionChange = (selected) => { setDefinition(selected?.id || ""); };
  const handleStateChange = (event) => { setState(event.target.value); };
  const handleControlableChange = (event) => {
    if (controlable) //if we go to non controlable
    {
      if (state === 1)
        setState(0);//go to viewer if saver
    }
    setControlable(!controlable);
  };

  const handleDefinitionUpdateChange = (event) => {
    setDefinitionUpdate(!definitionUpdate);
  };
  const handleStateUpdateChange = (event) => {
    setState(0);
    setStateUpdate(!stateUpdate);
  };
  const handleControlableUpdateChange = (event) => {
    setControlable(false);
    setControlableUpdate(!controlableUpdate);
  };
  const handleGroupsUpdateChange = (event) => {
    setGroupid("");
    setGroupsUpdate(!groupsUpdate);
  };

  const classes = useStyles();

  const handleSubmit = (event) => {
    updatePoint(event);
    closeModal();
  };

  useEffect(() => {
    let disabled = false;
    if (!definitionUpdate && !stateUpdate && !controlableUpdate && !groupsUpdate)
      disabled = true;
    else {
      if (definitionUpdate && !definition)
        disabled = true;
      if (groupsUpdate && (!groupid || groupid.length === 0))
        disabled = true;
    }
    setButtonDisabled(disabled);
  }, [definitionUpdate, stateUpdate, controlableUpdate, groupsUpdate, definition, groupid]);

  const updatePoint = async (event) => {
    const updated = points.map((point) => {
      let updatepoint = { ...point };
      if (definitionUpdate)
        updatepoint.definition = definition;
      if (stateUpdate)
        updatepoint.state = state;
      if (controlableUpdate)
        updatepoint.controlable = controlable;
      if (groupsUpdate)
        updatepoint.groupid = groupid;
      return (
        updatepoint
      );
    });
    axios
      .put(
        putPoints("update"),
        {
          points: updated,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Points modifiés");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        // setLoading(false);
      });
  };

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <GridContainer>
              <GridItem xs={2} sm={2} md={2} lg={2}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={definitionUpdate}
                    handleSwitchChange={handleDefinitionUpdateChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={10} sm={10} md={10} lg={10}>
                <div>
                  <AutocompleteInputMeters
                    disabled={!definitionUpdate}
                    specialWidth={"97%"}
                    inputMargin={"1rem 0rem 0rem"}
                    inputTitle={"Définition"}
                    selected={selectedDefinition()}
                    list={dicowithequipmentname}
                    handleChange={(_, newValue) =>
                      handleDefinitionChange(newValue)
                    }
                  />
                </div>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={2} sm={2} md={2} lg={2}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={stateUpdate}
                    handleSwitchChange={handleStateUpdateChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={10} sm={10} md={10} lg={10}>
                <div>
                  <CustomSelect
                    disabled={!stateUpdate}
                    inputTitle={"Etat"}
                    selectValue={state}
                    handleSelectValueChange={handleStateChange}
                    data={controlable ? stateData : stateNotControlableData}
                  />
                </div>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={2} sm={2} md={2} lg={2}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={controlableUpdate}
                    handleSwitchChange={handleControlableUpdateChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={10} sm={10} md={10} lg={10}>
                <div>
                  <CustomSwitch
                    disabled={!controlableUpdate}
                    style={{ margin: "10px 0 0 3px" }}
                    inputTitle={"Point pilotable"}
                    checkedState={controlable}
                    handleSwitchChange={handleControlableChange}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div>
              <CustomSwitch
                inputTitle={'Modifier le périmètre'}
                checkedState={groupsUpdate}
                handleSwitchChange={handleGroupsUpdateChange}
              />
            </div>
            {groupsUpdate &&
              <div
                className={classes.treeVisible}
              >
                <TreeLabel>Choix du périmètre</TreeLabel>
                <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                  <EmbeddedEntitesTree
                    selectedIds={setGroupid}
                    userSelectedIds={groupid}
                  />
                </ImageList>
              </div>
            }
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>

    </>
  );
}

export default PointDialog;
